export default __webpack_public_path__ + "static/media/drip1.c4fe7d49.jpeg";